import FormSection from '../../../../components/atom/FormSection';
import { Grid, TextField } from '@material-ui/core';
import AutocompleteSelect from '../../../../components/atom/AutocompleteSelect';
import { discountPackageAutocomplete } from '../../../../autocomplete';
import { Alert } from '@material-ui/lab';
import { useState } from 'react';

const ClientDiscountSelector = ({ clientId, setFieldValue, values }) => {
    // this is just a temp storage, do NOT use it during submit
    const [selectedDiscount, setSelectedDiscount] = useState({});
    // example : {"agencyDiscount":{"amount":"10","type":"$"},"vendorDiscount":{"amount":"0","type":"$"}}
    // have a warning if a discount amount is non zero but the type is not $, since those are not supported for clients
    const warningMessage =
        (selectedDiscount.agencyDiscount &&
            (selectedDiscount.agencyDiscount.amount !== '0' ||
                selectedDiscount.agencyDiscount.amount !== '') &&
            selectedDiscount.agencyDiscount.type === '%' &&
            'Warning: Agency discount type is not in $ which is not supported for clients.') ||
        (selectedDiscount.vendorDiscount &&
            (selectedDiscount.vendorDiscount.amount !== '0' ||
                selectedDiscount.vendorDiscount.amount !== '') &&
            selectedDiscount.vendorDiscount.type === '%' &&
            'Warning: Vendor discount type is not in $ which is not supported for clients.') ||
        null;

    return (
        <FormSection title="Default Discount">
            <Grid item xs={12}>
                {warningMessage && (
                    <Alert severity="warning" style={{ marginBottom: '1rem' }}>
                        {warningMessage}
                    </Alert>
                )}
                <AutocompleteSelect
                    initCall={ids => discountPackageAutocomplete.initOnlyCartLevel(ids, clientId)}
                    autocompleteCall={(search, page) =>
                        discountPackageAutocomplete.searchOnlyCartLevel(search, page, clientId)
                    }
                    value={values.default_discount || ''}
                    setValue={(newValue, getItem) => {
                        setFieldValue('default_discount', newValue);
                        setSelectedDiscount(getItem(newValue) || {});
                    }}
                >
                    <TextField label="Discount" />
                </AutocompleteSelect>
            </Grid>
        </FormSection>
    );
};

export default ClientDiscountSelector;
